/* eslint-disable no-console */

import {
  SET_ALERT_STATUS,
  INTERNSHIP_REQUEST_CALLBACK,
  GET_SEMINAR_BY_TYPE
} from '../constants/actionTypes';
import {
  requestCallbackApi,
  getSeminarByTypeApi
} from '../api/v1/summerInternship';

export const setAlertStatus = value => ({
  type: SET_ALERT_STATUS,
  payload: value
});

export const requestCallback = params => (dispatch, start) => {
  start(INTERNSHIP_REQUEST_CALLBACK);
  return requestCallbackApi(params).then(res => {
    dispatch(setAlertStatus('sucess'));
    return res;
  });
};

export const getSeminarByType = seminar_type => (dispatch, start) => {
  start(GET_SEMINAR_BY_TYPE);
  return getSeminarByTypeApi(seminar_type).then(response => {
    return { value: response.data };
  });
};



// WEBPACK FOOTER //
// ./src/actions/summerInternships.js